/**
 * @generated SignedSource<<d15550ffe78f79532c4289e61e5ae6a3>>
 * @relayHash 86eee1df6094e24479a425e1be0955bf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86eee1df6094e24479a425e1be0955bf

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type MedicalReportAttachmentsChangedReason = "UPLOAD_SESSION_REVERTED" | "UPLOAD_STATUS_CHANGED";
export type chMedicalReportSubscription$variables = {
  patientId: string;
};
export type chMedicalReportSubscription$data = {
  readonly medicalReportAttachmentsChanged: {
    readonly attachments: ReadonlyArray<{
      readonly attachmentType: DocumentType;
      readonly fileName: string;
      readonly id: string;
      readonly progressNoteId: string;
      readonly updatedAt: string | null;
      readonly uploadStatus: FileUploadStatus | null;
      readonly url: string;
    }>;
    readonly reason: MedicalReportAttachmentsChangedReason;
  };
};
export type chMedicalReportSubscription = {
  response: chMedicalReportSubscription$data;
  variables: chMedicalReportSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "alias": "medicalReportAttachmentsChanged",
    "args": [
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "MedicalReportAttachmentsChange",
    "kind": "LinkedField",
    "name": "ch_medicalReportAttachmentsChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicalReportAttachment",
        "kind": "LinkedField",
        "name": "attachments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attachmentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chMedicalReportSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chMedicalReportSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "86eee1df6094e24479a425e1be0955bf",
    "metadata": {},
    "name": "chMedicalReportSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "d02706a7b7e44e0125ec91b2d30cf362";

export default node;
